module.exports = __webpack_public_path__ + "static/img/task_book.778d2665.png";